import React from "react";
import { Outlet, useLocation, useOutlet } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import WorkNavbar from "../../components/WorkNavbar";
import useAnimation from "../../components/useAnimation";
import PageEnterOverlay from "../../components/PageEnterOverlay";

const layoutTransition = { layout: { duration: 0.4, ease: [0.33, 1, 0.68, 1] } };

const contentTransition = { duration: 0.35, ease: [0.33, 1, 0.68, 1] };
const contentVariants = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
};

const Work = () => {
  const location = useLocation();
  const outlet = useOutlet();
  const isWorkPage = location.pathname === "/work";
  const { isAnimating, animationMode } = useAnimation(
    1200,
    location.state?.fromTransition,
  );

  return (
    <div className="relative min-h-screen">
      <div className="fixed inset-0 bg-deep -z-10"></div>
      <PageEnterOverlay
        show={isAnimating}
        mode={animationMode}
        direction="left"
        bgClass="bg-lightBrown"
      />
      <div className="text-beige flex flex-col-reverse md:h-screen md:pt-[2rem] md:flex-row">
        <motion.div
          layout
          transition={layoutTransition}
          className={`${isWorkPage ? "px-4 md:px-0 md:w-2/3" : "md:w-1/4"}`}
        >
          <WorkNavbar isWorkPage={isWorkPage} />
        </motion.div>
        <motion.div
          layout
          transition={layoutTransition}
          className={`${
            isWorkPage
              ? "md:flex md:items-end md:w-1/3 md:pb-[8rem] md:pr-4"
              : "md:w-3/4 md:p-4 md:overflow-y-auto"
          }`}
        >
          {isWorkPage && (
            <div className="pt-16 md:pt-16 p-4 md:fixed md:text-base md:mr-32">
              {/* desktop view overview */}
              <h1 className="hidden md:block md:mb-3 md:font-bold md:text-xl ">
                WORK.
              </h1>
              {/* mobile view work page overview */}
              <h1 className="md:hidden font-extrabold text-7xl pb-2">WORK.</h1>
              <div className="px-2 md:px-0 md:text-lg">
                <p className="md:mb-1 ">
                  This portfolio showcases my expertise across diverse areas,
                  including frontend development, responsive web design, and
                  interactive user interfaces.{" "}
                </p>
                <p>
                  The field of frontend engineering is ever-changing, driven by
                  new technologies and trends. I'm committed to continuous
                  learning and honing my skills to create seamless and engaging
                  digital experiences.
                </p>
              </div>
              {/* - - - - - - - - - - - - - - line  - - - - - - - - - - - - - -*/}
              <div className="flex items-center justify-center pt-3 md:hidden">
                <p className="font-black text-lightDeep text-xl">
                  - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                  -
                </p>
              </div>
            </div>
          )}
          {outlet ? (
            <AnimatePresence mode="wait">
              <motion.div
                key={location.pathname}
                variants={contentVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={contentTransition}
                className="w-full min-h-0"
              >
                {outlet}
              </motion.div>
            </AnimatePresence>
          ) : (
            <Outlet />
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default Work;
